import { render, staticRenderFns } from "./PeterZaitsev.vue?vue&type=template&id=6ecc42be&scoped=true"
import script from "./PeterZaitsev.vue?vue&type=script&lang=js"
export * from "./PeterZaitsev.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecc42be",
  null
  
)

export default component.exports